import "./InputBox.css";

export const inputBoxClassName = "calmlens-input-box";
export const inputBoxGroupClassName = "calmlens-input-box-group";
